import z from "zod";

export const serviceFulfillmentPartnerSchemaForm = z.object({
	contactId: z.uuid(),
});

export type ServiceFulfillmentPartnerFormSchema = z.infer<
	typeof serviceFulfillmentPartnerSchemaForm
>;
